import React from 'react';
import { mount, compose, route, redirect, map } from 'navi';
import { Entry } from '@2022-contest-web/components/src/types';
import { ProfileApp } from './[id]';
import { getResourceService } from 'retil';
import { entryList } from '../../resources';

const fromPairs = require('lodash.frompairs');

export default compose(
    map(async () => {
        const [source] = getResourceService(entryList);
        const list = await source.getData();
        return mount({
            ...fromPairs(
                list.map((profile: Entry) => [
                    `/${profile.entry_id}`,
                    map(() => route({ getView: () => <ProfileApp entry={profile} /> })),
                ]),
            ),
        });
    }),
);